import { omitPathParameters, replacePathParameters } from "../../utils";
import type { AxiosInstance, AxiosRequestConfig } from "axios";
import type * as Paths from "./paths";

export const getCategoryOperations = (client: AxiosInstance) => {
  const getList = (
    parameters: Paths.GetList.QueryParameters,
    data?: any,
    config?: AxiosRequestConfig,
  ) => {
    const url = "/category";
    return client.get<Paths.GetList.Responses.$200>(
      replacePathParameters(url, parameters),
      {
        params: omitPathParameters(parameters, url),
        data: data,
        ...config,
      },
    );
  };
  const createRecord = (
    parameters: any,
    data: Paths.CreateRecord.RequestBody,
    config?: AxiosRequestConfig,
  ) => {
    const url = "/category";
    return client.post<Paths.CreateRecord.Responses.$200>(
      replacePathParameters(url, parameters),
      data,
      {
        params: omitPathParameters(parameters, url),
        ...config,
      },
    );
  };
  const getRecord = (
    parameters: Paths.GetRecord.QueryParameters &
      Paths.GetRecord.PathParameters,
    data?: any,
    config?: AxiosRequestConfig,
  ) => {
    const url = "/category/{id}";
    return client.get<Paths.GetRecord.Responses.$200>(
      replacePathParameters(url, parameters),
      {
        params: omitPathParameters(parameters, url),
        data: data,
        ...config,
      },
    );
  };
  const updateRecord = (
    parameters: Paths.UpdateRecord.PathParameters,
    data?: any,
    config?: AxiosRequestConfig,
  ) => {
    const url = "/category/{id}";
    return client.put<Paths.UpdateRecord.Responses.$200>(
      replacePathParameters(url, parameters),
      data,
      {
        params: omitPathParameters(parameters, url),
        ...config,
      },
    );
  };
  const deleteRecord = (
    parameters: Paths.DeleteRecord.PathParameters,
    data?: any,
    config?: AxiosRequestConfig,
  ) => {
    const url = "/category/{id}";
    return client.delete(replacePathParameters(url, parameters), {
      params: omitPathParameters(parameters, url),
      data: data,
      ...config,
    });
  };

  return {
    getList,
    createRecord,
    getRecord,
    updateRecord,
    deleteRecord,
  };
};
